import { render, staticRenderFns } from "./imageScroll.vue?vue&type=template&id=a3975012&scoped=true"
import script from "./imageScroll.vue?vue&type=script&lang=js"
export * from "./imageScroll.vue?vue&type=script&lang=js"
import style0 from "./imageScroll.vue?vue&type=style&index=0&id=a3975012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3975012",
  null
  
)

export default component.exports